import moment from 'moment';
import {
  REPORT_BY_NEW,
  REPORT_BY_RECURRUNG,
  REPORT_BY_DUPLICATED,
  REPORT_BY_UNDUPLICATED,
  REPORT_BY_LABELS,
  NEW_BY_CALENDAR_YEAR,
  NEW_BY_FISCAL_YEAR,
  NEW_BY_MONTH,
  NEW_BY_EVER,
  NEW_BY_SELECTED_DATE,
  NEW_BY_LABELS,
  RESULT_BY_DAY,
  RESULT_BY_WEEK,
  RESULT_BY_MONTH,
  RESULT_BY_YEAR,
  RESULT_BY_LABELS
} from '../../helpers/constants';
import { FiscalStartDate, FiscalEndDate } from '../../helpers/config';
import { visitTrackingMethodColumnToOption } from '../../containers/OutreachAggregateView/helpers/columnsToOptions';
import { visitTrackingMethod as visitTrackingMethodColumn } from '../../containers/OutreachAggregateView/helpers/customColumns';

const fiscalStartDate = moment(FiscalStartDate).toDate();
const fiscalEndDate = moment(FiscalEndDate).toDate();

const lastMonthStartDate = moment()
  .subtract(1, 'months')
  .startOf('month')
  .toDate();
const lastMonthEndDate = moment()
  .subtract(1, 'months')
  .endOf('month')
  .toDate();

export const dateRangesOptions = [
  {
    label: 'Last Month',
    value: [lastMonthStartDate, lastMonthEndDate]
  },
  {
    label: 'This Month',
    value: [
      moment()
        .startOf('month')
        .toDate(),
      moment()
        .endOf('month')
        .toDate()
    ]
  },
  {
    label: 'Calendar Year',
    value: [
      moment()
        .startOf('year')
        .toDate(),
      moment()
        .endOf('year')
        .toDate()
    ]
  },
  {
    label: 'Fiscal Year',
    value: [fiscalStartDate, fiscalEndDate]
  }
];

export const firstTimeByOptions = [
  { value: NEW_BY_CALENDAR_YEAR, label: NEW_BY_LABELS[NEW_BY_CALENDAR_YEAR] },
  { value: NEW_BY_FISCAL_YEAR, label: NEW_BY_LABELS[NEW_BY_FISCAL_YEAR] },
  { value: NEW_BY_MONTH, label: NEW_BY_LABELS[NEW_BY_MONTH] },
  { value: NEW_BY_EVER, label: NEW_BY_LABELS[NEW_BY_EVER] },
  { value: NEW_BY_SELECTED_DATE, label: NEW_BY_LABELS[NEW_BY_SELECTED_DATE] }
];

export const reportByOptions = [
  { value: REPORT_BY_NEW, label: REPORT_BY_LABELS[REPORT_BY_NEW] },
  { value: REPORT_BY_RECURRUNG, label: REPORT_BY_LABELS[REPORT_BY_RECURRUNG] },
  {
    value: REPORT_BY_DUPLICATED,
    label: REPORT_BY_LABELS[REPORT_BY_DUPLICATED]
  },
  {
    value: REPORT_BY_UNDUPLICATED,
    label: REPORT_BY_LABELS[REPORT_BY_UNDUPLICATED]
  }
];

export const resultByOptions = [
  {
    value: RESULT_BY_DAY,
    label: RESULT_BY_LABELS[RESULT_BY_DAY]
  },
  {
    value: RESULT_BY_WEEK,
    label: RESULT_BY_LABELS[RESULT_BY_WEEK]
  },
  {
    value: RESULT_BY_MONTH,
    label: RESULT_BY_LABELS[RESULT_BY_MONTH]
  },
  {
    value: RESULT_BY_YEAR,
    label: RESULT_BY_LABELS[RESULT_BY_YEAR]
  }
];

export const visitTrackingMethodOption = visitTrackingMethodColumnToOption(
  visitTrackingMethodColumn
);
